<template>
  <!-- inset height="70" -->
  <v-footer  dark padless app absolute inset class="bg-blur d-flex justify-center align-center" >
    <!-- <v-card class="flex" color="#078fc3" flat tile>
      <v-card-text class="py-2 white--text text-center">
        <h3>Powered by DCM © 2021</h3>
      </v-card-text>
    </v-card> -->
    <!-- 
     <router-link  color="white" to="/account-detail">Contact</router-link> -->

     <!-- style="background: linear-gradient(135deg, #ffffff, #ffffff, #ffffff, #ffffff, #9EE0F8, #9EE0F8, #ffffff);" -->
    <v-card class="flex bg-blur" flat tile style="background-color: #FAFAFA;">
       <v-row class="footer-main pt-10 mx-0" justify="center">
  <v-col cols="10" class="mb-6">
    <div class="d-flex align-center">
      <v-img
        src="../../assets/logo.png"
        max-height="50"
        max-width="50"
        @click="onClickMenu('/')"
      ></v-img>
      <h2 class="brand-name">Dmeets</h2>
    </div>
  </v-col>
  <v-col cols="10" class="pa-0 mb-6">
    <v-divider class="footer-divider"></v-divider>
  </v-col>
</v-row>

      <v-row class="footer-main mx-0 py-0" justify="center" :class="{'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown }">

  <!-- Explore -->
  <v-col cols="12" sm="4" md="3">
    <h3 class="footer-heading mb-4">Explore</h3>
    <div class="d-flex flex-column">
      <a class="footer-link mb-2" @click="onClickMenu('/about')">{{ lg_header_menu.about }}</a>
      <a class="footer-link mb-2" @click="onClickMenu('/pricing')">{{ lg_header_menu.feature }}</a>
      <a class="footer-link mb-2" @click="onClickMenu('/contact')">{{ lg_header_menu.contact }}</a>
    </div>
  </v-col>

  <!-- Platform -->
  <v-col cols="12" sm="4" md="3">
    <h3 class="footer-heading mb-4">Platform</h3>
    <div class="d-flex flex-column">
      <a class="footer-link mb-2" @click="showPrivacyPolicy_1">{{ lg_footer.privacy_policy }}</a>
      <a class="footer-link mb-2" @click="showDmeetsdocx_4">{{ lg_footer.terms_and_conditions }}</a>
      <a class="footer-link mb-2" @click="showInformationSecurityPolicy_2">{{ lg_footer.information_security_policy }}</a>
      <a class="footer-link mb-2" @click="showDmeetsdocx_5">{{ lg_footer.recording_consent_policy }}</a>
    </div>
  </v-col>

  <!-- App Store -->
  <v-col cols="12" sm="4" md="4" class="d-flex flex-column justify-start align-start align-sm-end">
      <div class="contact-items">
              <!-- Address -->
              <div class="contact-item d-flex align-start mb-4">
                <div class="contact-icon-wrapper mr-3">
                  <v-icon color="#1a3a6b" size="18">mdi-map-marker</v-icon>
                </div>
                <p class="contact-text mb-0">
                  942/69 Charn Issara Tower 1, 2nd Floor, Rama 4 Road<br>
                  Suriyawong Sub-district, Bang Rak District, Bangkok 10500
                </p>
              </div>

              <!-- Phone -->
              <div class="contact-item d-flex align-center mb-4">
                <div class="contact-icon-wrapper mr-3">
                  <v-icon color="#1a3a6b" size="18">mdi-phone</v-icon>
                </div>
                <p class="contact-text mb-0">+66 2233-0055 , +66 2233-0068</p>
              </div>

              <!-- Email -->
              <div class="contact-item d-flex align-center">
                <div class="contact-icon-wrapper mr-3">
                  <v-icon color="#1a3a6b" size="18">mdi-email</v-icon>
                </div>
                <p class="contact-text mb-0">contact@dcm.co.th</p>
              </div>
            </div>

  </v-col>

  <!-- Divider -->
  <v-col cols="10" class="pa-0 mt-6">
    <v-divider class="footer-divider"></v-divider>
  </v-col>

</v-row>

         
      <!-- <v-card-text v-if="!$store.getters['isLogin'] && !$vuetify.breakpoint.xsOnly" :class="textposition" class="footer-wrapper"> -->
        <!-- <v-btn
          text
          rounded
          class="my-2"
          href="https://www.dcm.co.th/wp-content/uploads/2021/12/DCMPrivacyPolicy.pdf"
          target="_blank"
          >{{ this.lg_footer.privacy_policy }}</v-btn
        > -->

        <!-- <v-btn
          color="white"
          text
          rounded
          class="my-2"
          @click="showPrivacyPolicy_1"
          target="_blank"
          ><h4>{{ this.lg_footer.privacy_policy }}</h4></v-btn
        > -->
        <!-- <v-btn
          color="white"
          text
          rounded
          class="my-2"
          href="https://www.dcm.co.th/wp-content/uploads/2021/12/InformationSecurityPolicy.pdf"
          target="_blank"
          >{{ this.lg_footer.information_security_policy }}</v-btn
        > -->

         <!-- <v-btn
          color="black"
          text
          rounded
          class="my-2"
          @click="showDmeetsdocx_4"
          target="_blank"
          ><h4>{{ this.lg_footer.terms_and_conditions }}</h4></v-btn
        > -->


        <!-- <v-btn
          color="black"
          text
          rounded
          class="my-2"
          @click="showInformationSecurityPolicy_2"
          target="_blank"
          ><h4>{{ this.lg_footer.information_security_policy }}</h4></v-btn
        > -->

        
        <!-- <v-btn
          color="black"
          text
          rounded
          class="my-2"
          @click.prevent="$router.push('/my-data-rights-form')"
          ><h4>{{ this.lg_footer.request_form }}</h4></v-btn
        > -->
        <!-- <v-btn
          color="black"
          text
          rounded
          class="my-2"
          @click.prevent="showDmeetsdocx_5"
          ><h4>{{ this.lg_footer.recording_consent_policy }}</h4></v-btn
        > -->
        <!-- <v-btn
          color="white"
          text
          rounded
          class="my-2"
          href="https://www.dcm.co.th/wp-content/uploads/2021/12/InformationSecurityPolicy.dmeetsdocx.pdf"
          target="_blank"
          >{{ this.lg_footer.information_technology_security_policy }}
        </v-btn> -->

        <!-- <v-btn
          color="white"
          text
          rounded
          class="my-2"
          @click="showTermandConditions_3"
          target="_blank"
          >{{ this.lg_footer.information_technology_security_policy }}
        </v-btn> -->

        <!-- <v-btn
          color="white"
          text
          rounded
          class="my-2"
          href="https://www.dcm.co.th/wp-content/uploads/2021/12/TermandConditions.pdf"
          target="_blank"
          >{{ this.lg_footer.terms_and_conditions }}</v-btn
        > -->
      <!-- </v-card-text> -->

  <!-- Explore -->
      <v-card-text class="py-0 white--text text-center pt-6" >
        <v-row class="py-0 ma-0">
          <v-col cols="12" md="6">
       <h4 v-if="checklanguage=='th'">© สงวนลิขสิทธิ์ {{ new Date().getFullYear() }} บริษัท ดิจิทัล คอร์ปอเรท เมเนจเม้นท์ จำกัด</h4> 
       <h4 v-else>© Copyright {{ new Date().getFullYear() }}. Digital Corporate Management Co., Ltd. All Rights Reserved.</h4>
        <!-- <strong>Powered by DCM ©</strong>-{{ new Date().getFullYear() }}
        <strong>Version {{ this.version }}</strong> -->
        </v-col>
          <v-col cols="12" sm="6" class="d-flex justify-center align-center">
            <!-- App Store Badge -->
            <a href="https://apps.apple.com/th/app/dmeets/id6479974253" target="_blank" class="store-badge mr-3">
              <div class="store-btn d-flex align-center px-3 py-2">
                <v-icon color="white" size="20" class="mr-2">mdi-apple</v-icon>
                <div>
                  <div class="store-sub">Download on the</div>
                  <div class="store-main">App Store</div>
                </div>
              </div>
            </a>
            <!-- Google Play Badge -->
            <a href="https://play.google.com/store/apps/details?id=com.dcm.dmeetszoom.dcm_dmeetszoom" target="_blank" class="store-badge">
              <div class="store-btn d-flex align-center px-3 py-2">
                <v-icon color="white" size="20" class="mr-2">mdi-google-play</v-icon>
                <div>
                  <div class="store-sub">Get it on</div>
                  <div class="store-main">Google Play</div>
                </div>
              </div>
            </a>
         </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import api from "../../services/api";
import { server } from "../../services/constants";
import { feature } from "../../services/constants";
import { lg_footer } from "../../views/language/lg_footer.js";
import {lg_header_menu} from '../../views/language/lg_header_menu.js';

export default {
  name: "Footer",
  data() {
    return {
      title: "Footer",
      version: "1.0",
      acc_plan: "FREE",
      date_exire: "",
      checklanguage:"",
      checklogin:false,
      exploreLinks: [],
      platformLinks: [],
    };
  },
   async mounted() {
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
    this.checklogin = api.isLoggedIn();
  },
  created() {
    // this.getVersion();
    // console.log("Footer created:" + this.getAccPlan());
  },
    computed: {
  textposition() {
    if(this.$vuetify.breakpoint.name === "xs"){
 return "py-0 white--text";
    }else{
       return "py-0 white--text text-center";
    }
  
    },
    },
  methods: {
     onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
    showPrivacyPolicy_1() {
      // window.open(`${window.location.origin}/1.DCMPrivacyPolicy.pdf`);
      window.open(`${window.location.origin}/privacy-policy`);
      // alert(window.location.host);
    },
    showInformationSecurityPolicy_2() {
      if(this.checklanguage == "th"){
      window.open(
        `${window.location.origin}/Information_Security_Policy_(TH).pdf`
      );
      }
      else{
        window.open(
        `${window.location.origin}/Information_Security_Policy_(ENG).pdf`
      );
      }
        // window.open(`${window.location.origin}/information-secureity-policy`);
      // alert(window.location.host);
    },
    showTermandConditions_3() {
      window.open(`${window.location.origin}/3.TermandConditions.pdf`);
      
      // alert(window.location.host);
    },
    showDmeetsdocx_4() {
      // window.open(
      //   `${window.location.origin}/4.InformationSecurityPolicy.dmeetsdocx.pdf`
      // );
       if(this.checklanguage == "th"){
       window.open(`${window.location.origin}/DCM_Terms_and_Conditions_(TH).pdf`);
      }else{
       window.open(`${window.location.origin}/DCM_Terms_and_conditions_(ENG).pdf`);
      }
      // alert(window.location.host);
    },
    showDmeetsdocx_5() {
      // window.open(
      //   `${window.location.origin}/4.InformationSecurityPolicy.dmeetsdocx.pdf`
      // );
      console.log(window.location)
       if(this.checklanguage == "th"){
       window.open(`${window.location.origin}/Recording_and_Consent_Policy_(TH).docx`);
      }else{
       window.open(`${window.location.origin}/Recording_and_Consent_Policy_(ENG).docx`);
      }
      // alert(window.location.host);
    },
    getVersion() {
      // console.log("Footer created:" + localStorage.getItem(server.ACC_PLAN_STA));
      if (localStorage.getItem(server.ACC_PLAN_STA) == "FREE") {
        this.version = server.VERSION_FREE;
      } else {
        this.version = server.VERSION_PREMIUM;
      }
    },
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;

    // alert(localStorage.getItem("language"))
    // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_footer = lg_footer.lg_footer_th)
      : (this.lg_footer = lg_footer.lg_footer_en);

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_menu = lg_header_menu.lg_header_menu_th
        : this.lg_header_menu = lg_header_menu.lg_header_menu_en;

    // console.log("lg_login: " + JSON.stringify(this.lg_login));
  },
};
</script>
<style type="text/css">
@media only screen and (max-width: 600px) {
  .v-btn:not(.v-btn--round).v-size--default {
    height: 20px;
  }
}
.footer-wrapper {
    /* background-color: #FAFAFA; */
    /* background: linear-gradient(135deg, #ffffff, #ffffff, #ffffff, #ffffff, #9EE0F8, #9EE0F8, #ffffff); */
}

.bg-blur{
    /* position: fixed; */
    /* position: absolute; */
  /* background-color: #FAFAFA!important; */
  /* background-color: rgba(255, 255, 255, 0) !important; */
   background-color: #1a3a6b !important;
  backdrop-filter: blur(0px) !important;
  -webkit-backdrop-filter: blur(0px) !important; 
  /* z-index: 1000 !important;  */
}
.store-badge {
  text-decoration: none;
}
.store-btn {
  background-color: #111827;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-width: 120px;
  transition: background-color 0.2s;
}
.store-btn:hover {
  background-color: #1f2937;
}
.store-sub {
  color: rgba(255, 255, 255, 0.65);
  font-size: 10px;
  line-height: 1;
}
.store-main {
  color: white;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}
.footer-link {
  color: rgba(255, 255, 255, 0.75) !important;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
  display: inline-flex;
  align-items: center;
}
.footer-link:hover {
  color: white !important;
}
.contact-icon-wrapper {
  width: 30px;
  height: 30px;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>
